import React, { useEffect } from 'react'
import { checkZipUserSubscription } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeUserZip } from '../../store/slices/userZipGameTokenSlice';

const ZipAuth = ({ children }) => {
    const { userZip } = useSelector(
        (state) => state?.persisted?.userZipGameTokenSlice
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const checkSubscription = async () => {
        try {
            const response = await checkZipUserSubscription(userZip?.token);

        } catch (error) {
            if (error?.response?.data?.error?.status == 0) {
                // user is not registered...
                dispatch(removeUserZip());
                navigate("/");

            }
            else if (error?.response?.status == 403) {
                dispatch(removeUserZip());
                navigate('/');
            }
            else {
                console.log("Don't do anything///");
            }
        }
    }

    useEffect(() => {
        if (userZip?.token) {
            checkSubscription();
        }
        else {
            navigate("/");
        }
    }, [userZip, location]);
    return (
        <>{children}</>
    )
}

export default ZipAuth